<div class="read-more no-links dynamic-html" *ngIf="data" [innerHTML]="data.moreInfo | safeHtml"></div>
